import axiosClient from "./axiosClient";

// API cấu hình nhắc/bắt buộc cập nhật app (iOS / Android).
// App đọc file tĩnh /img/app-version-gate.json; admin sửa qua endpoint này.
const appVersionGateApi = {
    getConfig() {
        return axiosClient.get("app-version-gate");
    },
    updateConfig(payload) {
        // payload: { ios: {...}, android: {...} }
        return axiosClient.put("app-version-gate", payload);
    },
    // Bundle JS (OTA) đang chạy thực tế trên máy user — KHÁC version binary ở trên.
    getClientStats(days = 14) {
        return axiosClient.get("app-version-gate/client-stats", { params: { days } });
    },
};

export default appVersionGateApi;
